  <h1>🌟 Notice Board</h1>

    <div class="board">
       
        <div class="quote-card">
            <div class="quote">" To all trainees , Please mail to "vishwanathph@gmail.com" for any clarifications in training sessions".
                you can contact me to the same mail , if you require any mini projects to workout. </div>
       </div>
        <div class="quote-card">
            <div class="quote">"Believe you can and you're halfway there."</div>
            <div class="author">– Theodore Roosevelt</div>
        </div>
    </div>